import React from 'react';
import { DividerBackgroundContainer, DividerContainer, DividerStrokeContainer } from './styles';
import { WaveSize, WavyDividerProps } from './types';
import { WavyEdge } from './WavyEdge';

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340769600244
 */
export const WavyDivider: React.FC<WavyDividerProps> = (props) => {
  const { className, backgroundColor, patternId = '', strokeColor, waveSize = WaveSize.SHORT, ...otherProps } = props;
  const wavyEdgeProps = {
    ...otherProps,
    waveSize,
  };

  return (
    <DividerContainer id='DividerContainer' className={className}>
      {backgroundColor && (
        <DividerBackgroundContainer id='DividerBackgroundContainer' color={backgroundColor}>
          <WavyEdge {...wavyEdgeProps} patternId={`${patternId}-fill`} />
        </DividerBackgroundContainer>
      )}
      <DividerStrokeContainer color={strokeColor}>
        <WavyEdge {...wavyEdgeProps} isStroke patternId={`${patternId}-stroke`} />
      </DividerStrokeContainer>
    </DividerContainer>
  );
};
